export enum SourceType {
  CSV = 'csv',
  AZURE_AD = 'azure-active-directory',
  GOOGLE = 'google-directory',
  LDAP = 'ldap',
  UKG = 'ukg',
  OKTA = 'okta',
  DEMO_DATA = 'demo-data',
  WORKDAY = 'workday',
  RHDS = 'rhds',
}

export default interface Source {
  authorizationStatus: AuthorizationStatus;
  createdAt: string;
  directoryId: string;
  fields?: any; // ?
  groups?: any; // ?
  id: string;
  isPrimary: boolean;
  label: string;
  settings: Settings;
  setupProgress: SetupProgress;
  syncEnabled: boolean;
  syncStatus: SyncStatus | null;
  type: SourceType;
}

export interface AuthorizationStatus {
  isAuthorized: boolean;
  authenticatedAt: number;
}

export interface CurrentSyncStatus {
  status: string;
  completedAt: string;
}

export interface LastSyncStatus {
  status: string;
  completedAt: string;
  error: {
    code: string;
    messageTxt: string;
  };
  counts: {
    sourceCount: number;
    skippedCount: number;
    createdCount: number;
    updatedCount: number;
    unchangedCount: number;
    reactivatedCount: number;
    deactivatedCount: number;
    collisionCount: number;
    invalidCount: number;
  };
}

export interface SyncStatus {
  state: number;
  startedAt: string;
  completedAt: string;
  type: string;
  status: string;
  currentSyncStatus: CurrentSyncStatus;
  lastSyncStatus: LastSyncStatus;
}

export interface Settings {
  photoSync: {
    enabled: boolean;
  };
}

export interface SetupProgress {
  isComplete?: boolean;
  syncCompletedDialogViewed?: boolean;
  csvOptOut?: boolean;
}
